import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { Typography } from '@material-ui/core'
import styled from 'styled-components'
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import CancelIcon from '@material-ui/icons/Cancel';
import RemoveIcon from '@material-ui/icons/Remove';

const useStyles = makeStyles(theme => ({
        legend: {
            color: '#4D4F5C',
            fontSize: '16px',
            opacity: 1,
            fontWeight: 'bold'
        },
        option: {
            color: '#4D4F5C',
            fontSize: '16px',
            opacity: 1,
            fontStyle: 'italic',
            marginLeft: 5
        }
    })
)

const LegendBlock = styled.div``

const LegendOptions = styled.div`
    display: flex;
    width: 100%;
    @media(max-width: 1050px) {
        flex-direction:column;
    }
`

const OptionBox = styled.div`
    display: flex;
    width: 15%;
`

const QuizResultsLegend = () => {
    const classes = useStyles();

    return (
        <LegendBlock>
            <Typography gutterBottom variant="h6" component="h1" className={classes.legend}>
                Legenda
            </Typography>
            <LegendOptions>
                <OptionBox>
                    <CheckCircleIcon style={{ color: 'green' }}/>
                    <Typography gutterBottom variant="h6" component="h1" className={classes.option}>
                        Correta
                    </Typography>
                </OptionBox>
                <OptionBox>
                    <CancelIcon style={{ color: 'red' }}/>
                    <Typography gutterBottom variant="h6" component="h1" className={classes.option}>
                        Incorreta
                    </Typography>
                </OptionBox>
                <OptionBox>
                    <RemoveIcon style={{ color: 'rgba(19,124,189,.6)' }} />
                    <Typography gutterBottom variant="h6" component="h1" className={classes.option}>
                        Selecionada
                    </Typography>
                </OptionBox>
            </LegendOptions>
        </LegendBlock>
    )
}

export default QuizResultsLegend